import { gsap } from 'gsap';
import Win from '../_app/cuchillo/windows/Window';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class FiltersWindow extends Win {
  engine;
  drawer;
  overlay;

  constructor(__container, __id) {
    super(__container, __id);
    this.drawer = GetBy.selector('.drawer', this.container)[0];
    this.overlay = GetBy.selector('.overlay', this.container)[0];

    // GSAP must own the initial transform: a static CSS translateX(-100%) gets
    // baked into the computed matrix and read back as a plain px offset, which
    // then stacks on top of (rather than being replaced by) the xPercent tween.
    gsap.set(this.drawer, { xPercent: -100 });
  }

  show__effect(__d = 0) {
    gsap.to(this.drawer, { xPercent: 0, duration: .8, ease: 'power3.inOut', onComplete: () => { this.afterShow(); } });
    if (this.overlay) gsap.to(this.overlay, { opacity: .4, duration: .8, ease: 'power3.inOut' });
  }

  hide__effect(__d = 0) {
    gsap.to(this.drawer, { xPercent: -100, duration: .3, ease: 'power2.out', onComplete: () => { this.afterHide(); } });
    if (this.overlay) gsap.to(this.overlay, { opacity: 0, duration: .3, ease: 'power2.out' });
  }

  afterShow() {
    super.afterShow();
    if (this.engine) this.engine.enabled = true;
  }

  afterHide() {
    super.afterHide();
    if (this.engine) this.engine.enabled = false;
  }
}
